// extracted by mini-css-extract-plugin
export var actions = "_2d-0";
export var actionsContainer = "_2d-7";
export var border = "_2d-1";
export var childFullHeight = "_2d-f";
export var collapse = "_2d-2";
export var content = "_2d-a";
export var contentChild = "_2d-e";
export var fullscreen = "_2d-c";
export var hasLeftRadius = "_2d-k";
export var headerContainer = "_2d-3";
export var headerRow = "_2d-5";
export var hidePadding = "_2d-b";
export var navCollapsedGap = "_2d-l";
export var noScrollX = "_2d-m";
export var noScrollY = "_2d-n";
export var noTopPadding = "_2d-i";
export var optOutTopPadding = "_2d-d";
export var pageMain = "_2d-j";
export var pageOuter = "_2d-g";
export var pagePadding = "_2d-8";
export var pageScroll = "_2d-9";
export var profile = "_2d-o";
export var profileContainer = "_2d-p";
export var profileImage = "_2d-q";
export var profileMain = "_2d-r";
export var profileSubtitle = "_2d-t";
export var profileTitle = "_2d-s";
export var showLeftPadding = "_2d-h";
export var tabsPortalSlot = "_2d-6";
export var tabsWrapper = "_2d-4";
export var title = "_2d-u";